import { ref } from 'vue'

export type KK = number // 键盘实际对应的按键值
export type VK = number // 按键功能值 https://learn.microsoft.com/en-us/windows/win32/inputdev/virtual-key-codes
export type LK = number // 键盘灯光对应的按键值
export type EffectIndex = number // 键盘灯效对应的索引
export const kks = ref<{ [index: KK]: VK }>({})

export enum DevicePid {
  None = 0x0,

  IROKAl87 = 0x258a00d4,
  IROKAl87Rgb = 0x258a00e2,
  IROKAl87Pro = 0x258a00bd,
  IROKFe75Pro = 0x258a00fc,
  IROKFe98Pro = 0x258a00fb,
  IROKHe2 = 0x258a1007,
  IROKHe3SE_Wireless_24g = 0x0c45c077,
  IROKHe3SE_Wireless = 0x0c450500,
  IROKMg87 = 0x258a010c,

  IROKNA87 = 0x304167372,
  IROKNd75 = 0x204167372,
  IYXMu68 = 0x104167372,

  IROKNa87Pro = 0x201c4fee88,
  IROKNd63 = 0x301c4fee88,
  IROKNd63_cyan = 0x311c4fee88,

  IROKQMKLi75 = 0x14806340,
  IYXOp75 = 0x258a018a,
  IYXTp87 = 0x258a018b,
  IYXMt87 = 0x258a01a6,

  IYXMu68Pro = 0x101c4fee88,
  IYXMu68Pro_cyan = 0x111c4fee88,
  IYXMu68_ULTRA = 0x121c4fee88,

  //IYXPolar75 = 0x401c4fee88,
  IYXPolar75 = 0x401ca30201,
  IYXAmber358_24g8k = 0x093a522c,
  IYXAmber358_Wired = 0x093a622c,

  CarotmasMars68Pro = 0x3031515029,
  CarotmasMars68Pro_Wireless = 0x31515030,
  CarotmasMars68Pro_Wireless_24g = 0x3151502b,

  CarotmasMars68 = 0x2031515029,
  CarotmasMars68SE = 0x1031515029,

  CarotmasMars68_Wireless = 0x4031515030,
  CarotmasMars68_Wireless_24g = 0x31515026,

  MonsGeek = 0x3151502d,
  MonsGeek_NoLight = 0x3151502e,
  MonsGeek_NoLight_24g = 0x31514011,

  IROKMg68 = 0x103151502d,
  IROKMg68SE = 0x203151502d,
  IROKMg68Pro = 0x303151502d,
  IROKMg68LITE = 0x403151502d,

  IROKMg68Max = 0x3151502f,
  IROKMg68Max_24g = 0x103151502b,

  IROKMg75 = 0x101ca50807,
  IROKMg75PRO = 0x201ca50807,

  CarotmasMer68 = 0x101ca50806,
  CarotmasMer68Pro = 0x111ca50806,
  CarotmasMer68SE = 0x4031515029,
  CarotmasMer68Lite = 0x4131515029,
  CarotmasMer68Max = 0x1ca6052d,

  CarotmasMars75 = 0x1ca6052b,
  CarotmasMars75Pro = 0x101ca6052b,

  He6Ultra = 0x3554fb36,
  He6Ultra_24g = 0x3554fb35,

  IROKMg68Plus = 0x1ca6052a,
  IROKMg75Max = 0x1ca60529,

  IROKMG68ACE = 0x5031515029,
  IROKMG68ACE_UpPlus = 0x5131515029,
  IROKMG68ACE_W = 0x5131515030,
  IROKMG68ACE_W_24g = 0x5231515038,

  IROKND68Pro = 0x1ca6052c,
  IROKND63Ultra = 0x1ca60531,

  IROKND68 = 0x31515029,
  IROKND63Max = 0x603151502d,

  IrokFe87V2 = 0x19bf1020,
  IrokFe87V2_24g = 0x1a868300,

  CarotmasMer68SESelfDev = 0x19bf1010,
  IrokFe87V2IMC = 0x19bf1030,
  IrokFe87V2IMC_24g = 0x101a868300,

  // IROK FeV2 C18：FE87 V2 单模 机械键盘，与 IrokFe87V2(C38) 共用 VID/PID(0x19bf/0x1020)，
  // 借助 secondaryProductId=0x10 区分，无 2.4G 变体。
  IrokFe87V2C18 = 0x1019bf1020,

  IROKRA68 = 0x1ca60528,

  IROKMG63 = 0x2f813004,
  IROKRA68_1 = 0x2f813005,
  IROKMG75V2C12 = 0x2f813007,
  IROKMG63V2 = 0x19f55765,
  IROKFE87V2_MuYan = 0x28e9320e,
}

export const EEvisionDeviceList = new Map()
EEvisionDeviceList.set(0x0c457638, 'IK6-M')
EEvisionDeviceList.set(0x320f504e, 'Fe87')
EEvisionDeviceList.set(0x320f5051, 'Fe104')
EEvisionDeviceList.set(0x320f505d, 'Fe87 RGB')
EEvisionDeviceList.set(0x320f505e, 'Fe104 RGB')
EEvisionDeviceList.set(0x320f5083, 'AL87')
EEvisionDeviceList.set(0x320f50ad, 'Fe104 Mixed')
EEvisionDeviceList.set(0x320f50ae, 'Fe87 Mixed')

export const getKKByVK = (vk: VK): KK | null => {
  for (const [kk, value] of Object.entries(kks.value)) {
    if (value == vk) {
      return Number(kk) as KK
    }
  }
  return null
}
